import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  position: absolute;
  top: 40px;
  right: 42px;
  cursor: pointer;
`;

export const openAnimation = (itemsCount: number) => keyframes`
    0%{
      height:0;
    }
  
    100%{
      height:${(itemsCount + 1) * 2.25}rem;
    }
`;

export const MenuList = styled.ul<{ itemsCount: number }>`
  position: absolute;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.neutral[0]};
  overflow: hidden;
  z-index: 10;
  animation: ${({ itemsCount }) => openAnimation(itemsCount)} 0.2s;
`;

export const MenuItem = styled.li`
  width: 8.75rem;
  height: 2.5rem;
  padding: 0.563rem 1rem;
  color: ${({ theme }) => theme.colors.neutral[700]};
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.shopl[300]};
  }
`;

export const SelectedButton = styled.button`
  background-color: ${({ theme }) => theme.colors.neutral[0]};
  cursor: pointer;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  width: 140px;
  height: 42px;
  justify-content: space-between;
  padding: 10px 16px;
  outline: none;
  border-radius: 4px;
`;

export const SelectedText = styled.div`
  cursor: pointer;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.neutral[700]};
`;

export const Arrow = styled.div`
  width: 0.438rem;
  height: 0.438rem;
  transform: rotate(225deg);
  border-top: 1.5px solid grey;
  border-left: 1.5px solid grey;
`;
